import { getLocalizedValue } from '@grandvisionhq/utils';

const getProductTag = (variant, locale)=>{
    const zeroDiscount = getZeroDiscountValue(variant, locale);
    const tags = variant.tags;
    if (!(tags === null || tags === void 0 ? void 0 : tags.length) && !zeroDiscount) return undefined;
    // tags have more weight than a description from the zero discount
    if (tags && tags.length) {
        const value = typeof tags[0].value !== 'string' ? getLocalizedValue(tags[0].value, locale) : tags[0].value;
        return {
            key: tags[0].key,
            value
        };
    }
    // temporally uses zero discount as a custom product tag.
    return {
        key: null,
        value: zeroDiscount || ''
    };
};
// gets description value and to create a custom tag. remove this after the unification
const getZeroDiscountValue = (variant, locale)=>{
    var ref, ref1;
    if (!Array.isArray(variant.prices) || !variant.prices.length) {
        return undefined;
    }
    const { discounted  } = variant.prices[0];
    // check that discounted contains discount object
    if (!discounted || !((ref = discounted.discount) === null || ref === void 0 ? void 0 : ref.obj)) return undefined;
    const { value , description  } = (ref1 = discounted.discount) === null || ref1 === void 0 ? void 0 : ref1.obj;
    let discountLabel = null;
    if (value.type === 'absolute') {
        discountLabel = description && (value.money && value.money[0].centAmount) === 0 ? getLocalizedValue(description, locale) : null;
    } else if (value.type === 'relative') {
        discountLabel = description && value.permyriad === 0 ? getLocalizedValue(description, locale) : null;
    }
    return discountLabel;
};

export { getProductTag };
//# sourceMappingURL=get-product-tag.js.map
